import {
  Button,
  CustomRewardCurrency,
  CustomRewardLog,
  CustomRewardLogType,
  JoonUIColor,
  SPACING,
} from "@joonapp/web-shared"
import dayjs from "dayjs"
import { useState } from "react"
import toast from "react-hot-toast"
import { useTranslation } from "react-i18next"

import Card from "../../components/card/Card"
import { useUndoCustomRewardLogMutation } from "../../networking/rewards/mutations"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../util/analytics"
import { useRouter } from "../../util/router"

const RewardTransactionCard = ({
  currentRewardLog,
  allRewardLogs,
}: {
  currentRewardLog: CustomRewardLog
  allRewardLogs: CustomRewardLog[]
}) => {
  const [clickedLogId, setClickedLogId] = useState<number | null>(null)
  const undoCustomRewardLogMutation = useUndoCustomRewardLogMutation()
  const router = useRouter()
  const { t } = useTranslation()

  const onUndoClick = async (logId: number) => {
    await undoCustomRewardLogMutation.mutateAsync(logId)
    const clickedRewardLog = allRewardLogs?.find((log) => log.id === logId)
    const rewardCurrency = clickedRewardLog?.reward.currency
    const toastKey =
      clickedRewardLog?.type === CustomRewardLogType.PURCHASE
        ? "RTC_TOAST_PURCHASE"
        : rewardCurrency === CustomRewardCurrency.MINUTE
          ? "RTC_TOAST_APPROVAL"
          : "RTC_TOAST_USAGE"
    toast.success(t(toastKey))
  }

  const amountChange = Math.abs(currentRewardLog.amount_change)
  const minuteSuffix =
    currentRewardLog.reward.currency === CustomRewardCurrency.MINUTE
      ? amountChange === 1
        ? t("RTC_MINUTE_SUFFIX_ONE")
        : t("RTC_MINUTE_SUFFIX_OTHER")
      : ""
  const rewardLogTitle = `${currentRewardLog.reward.emoji} ${currentRewardLog.reward.title} (${currentRewardLog.reward.currency === CustomRewardCurrency.DOLLAR ? "$" : ""}${amountChange}${minuteSuffix})`
  const rewardSubtitleType =
    currentRewardLog.type === CustomRewardLogType.PURCHASE
      ? t("RTC_PURCHASED")
      : currentRewardLog.reward.currency === CustomRewardCurrency.MINUTE
        ? t("RTC_APPROVED")
        : t("RTC_USED")
  return (
    <Card
      title={rewardLogTitle}
      subtitle={t("RTC_SUBTITLE", {
        type: rewardSubtitleType,
        date: dayjs(currentRewardLog.date_created).format("MMM D, YYYY"),
      })}
      coinAmount={
        currentRewardLog.type === CustomRewardLogType.PURCHASE
          ? Math.abs(
              currentRewardLog.reward.cost * currentRewardLog.amount_change
            )
          : undefined
      }
      key={currentRewardLog.id}
      userIds={[currentRewardLog.user.id]}
      onClick={(e) => {
        e.stopPropagation()
        trackAnalyticEvent(ANALYTIC_EVENTS.VIEW_CUSTOM_REWARD_DETAILS)
        router.push(`/rewards/details/${currentRewardLog.reward.id}`)
      }}
      buttonComponent={
        currentRewardLog.can_undo && (
          <Button
            buttonType="secondary"
            size="small"
            onClick={(e) => {
              setClickedLogId(currentRewardLog.id)
              e.stopPropagation()
              onUndoClick(currentRewardLog.id)
            }}
            text={t("RTC_UNDO")}
            isLoading={
              undoCustomRewardLogMutation.isLoading &&
              clickedLogId === currentRewardLog.id
            }
            style={{
              minWidth: "53px",
              color: JoonUIColor.text.primary,
              borderRadius: SPACING.space2,
              border: `1px solid ${JoonUIColor.border.default}`,
              padding: `${SPACING.space1} ${SPACING.space2}`,
              height: "auto",
            }}
          />
        )
      }
    />
  )
}

export default RewardTransactionCard
